import { z } from "zod"

import { StateCode } from "../constants"

export const STATE_NAMES = [
  `Alabama`,
  `ALABAMA`,
  `Alaska`,
  `ALASKA`,
  `Arizona`,
  `ARIZONA`,
  `Arkansas`,
  `ARKANSAS`,
  `California`,
  `CALIFORNIA`,
  `Colorado`,
  `COLORADO`,
  `Connecticut`,
  `CONNECTICUT`,
  `Delaware`,
  `DELAWARE`,
  `Florida`,
  `FLORIDA`,
  `Georgia`,
  `GEORGIA`,
  `Hawaii`,
  `HAWAII`,
  `Idaho`,
  `IDAHO`,
  `Illinois`,
  `ILLINOIS`,
  `Indiana`,
  `INDIANA`,
  `Iowa`,
  `IOWA`,
  `Kansas`,
  `KANSAS`,
  `Kentucky`,
  `KENTUCKY`,
  `Louisiana`,
  `LOUISIANA`,
  `Maine`,
  `MAINE`,
  `Maryland`,
  `MARYLAND`,
  `Massachusetts`,
  `MASSACHUSETTS`,
  `Michigan`,
  `MICHIGAN`,
  `Minnesota`,
  `MINNESOTA`,
  `Mississippi`,
  `MISSISSIPPI`,
  `Missouri`,
  `MISSOURI`,
  `Montana`,
  `MONTANA`,
  `Nebraska`,
  `NEBRASKA`,
  `Nevada`,
  `NEVADA`,
  `New Hampshire`,
  `NEW HAMPSHIRE`,
  `New Jersey`,
  `NEW JERSEY`,
  `New Mexico`,
  `NEW MEXICO`,
  `New York`,
  `NEW YORK`,
  `North Carolina`,
  `NORTH CAROLINA`,
  `North Dakota`,
  `NORTH DAKOTA`,
  `Ohio`,
  `OHIO`,
  `Oklahoma`,
  `OKLAHOMA`,
  `Oregon`,
  `OREGON`,
  `Pennsylvania`,
  `PENNSYLVANIA`,
  `Puerto Rico`,
  `PUERTO RICO`,
  `Rhode Island`,
  `RHODE ISLAND`,
  `South Carolina`,
  `SOUTH CAROLINA`,
  `South Dakota`,
  `SOUTH DAKOTA`,
  `Tennessee`,
  `TENNESSEE`,
  `Texas`,
  `TEXAS`,
  `Utah`,
  `UTAH`,
  `Vermont`,
  `VERMONT`,
  `Virginia`,
  `VIRGINIA`,
  `Washington DC`,
  `WASHINGTON DC`,
  `Washington`,
  `WASHINGTON`,
  `West Virginia`,
  `WEST VIRGINIA`,
  `Wisconsin`,
  `WISCONSIN`,
  `Wyoming`,
  `WYOMING`,
] as const
export type StateName = (typeof STATE_NAMES)[number]
export const stateNameSchema = z.enum(STATE_NAMES, {
  description: `Must be a valid state name with a capital first letter or all caps. eg: California or CALIFORNIA.`,
})
export const StateNameToCode: Record<StateName, StateCode> = {
  "Alabama": StateCode.AL,
  "ALABAMA": StateCode.AL,
  "Alaska": StateCode.AK,
  "ALASKA": StateCode.AK,
  "Arizona": StateCode.AZ,
  "ARIZONA": StateCode.AZ,
  "Arkansas": StateCode.AR,
  "ARKANSAS": StateCode.AR,
  "California": StateCode.CA,
  "CALIFORNIA": StateCode.CA,
  "Colorado": StateCode.CO,
  "COLORADO": StateCode.CO,
  "Connecticut": StateCode.CT,
  "CONNECTICUT": StateCode.CT,
  "Delaware": StateCode.DE,
  "DELAWARE": StateCode.DE,
  "Florida": StateCode.FL,
  "FLORIDA": StateCode.FL,
  "Georgia": StateCode.GA,
  "GEORGIA": StateCode.GA,
  "Hawaii": StateCode.HI,
  "HAWAII": StateCode.HI,
  "Idaho": StateCode.ID,
  "IDAHO": StateCode.ID,
  "Illinois": StateCode.IL,
  "ILLINOIS": StateCode.IL,
  "Indiana": StateCode.IN,
  "INDIANA": StateCode.IN,
  "Iowa": StateCode.IA,
  "IOWA": StateCode.IA,
  "Kansas": StateCode.KS,
  "KANSAS": StateCode.KS,
  "Kentucky": StateCode.KY,
  "KENTUCKY": StateCode.KY,
  "Louisiana": StateCode.LA,
  "LOUISIANA": StateCode.LA,
  "Maine": StateCode.ME,
  "MAINE": StateCode.MN,
  "Maryland": StateCode.MD,
  "MARYLAND": StateCode.MD,
  "Massachusetts": StateCode.MA,
  "MASSACHUSETTS": StateCode.MA,
  "Michigan": StateCode.MI,
  "MICHIGAN": StateCode.MI,
  "Minnesota": StateCode.MN,
  "MINNESOTA": StateCode.MN,
  "Mississippi": StateCode.MS,
  "MISSISSIPPI": StateCode.MS,
  "Missouri": StateCode.MI,
  "MISSOURI": StateCode.MO,
  "Montana": StateCode.MT,
  "MONTANA": StateCode.MT,
  "Nebraska": StateCode.NE,
  "NEBRASKA": StateCode.NE,
  "Nevada": StateCode.NV,
  "NEVADA": StateCode.NV,
  "New Hampshire": StateCode.NH,
  "NEW HAMPSHIRE": StateCode.NH,
  "New Jersey": StateCode.NJ,
  "NEW JERSEY": StateCode.NJ,
  "New Mexico": StateCode.NM,
  "NEW MEXICO": StateCode.NM,
  "New York": StateCode.NY,
  "NEW YORK": StateCode.NY,
  "North Carolina": StateCode.NC,
  "NORTH CAROLINA": StateCode.NC,
  "North Dakota": StateCode.ND,
  "NORTH DAKOTA": StateCode.ND,
  "Ohio": StateCode.OH,
  "OHIO": StateCode.OH,
  "Oklahoma": StateCode.OK,
  "OKLAHOMA": StateCode.OK,
  "Oregon": StateCode.OR,
  "OREGON": StateCode.OR,
  "Pennsylvania": StateCode.PA,
  "PENNSYLVANIA": StateCode.PA,
  "Puerto Rico": StateCode.PR,
  "PUERTO RICO": StateCode.PR,
  "Rhode Island": StateCode.RI,
  "RHODE ISLAND": StateCode.RI,
  "South Carolina": StateCode.SC,
  "SOUTH CAROLINA": StateCode.SC,
  "South Dakota": StateCode.SD,
  "SOUTH DAKOTA": StateCode.SD,
  "Tennessee": StateCode.TN,
  "TENNESSEE": StateCode.TN,
  "Texas": StateCode.TX,
  "TEXAS": StateCode.TX,
  "Utah": StateCode.UT,
  "UTAH": StateCode.UT,
  "Vermont": StateCode.VT,
  "VERMONT": StateCode.VT,
  "Virginia": StateCode.VA,
  "VIRGINIA": StateCode.VA,
  "Washington DC": StateCode.DC,
  "WASHINGTON DC": StateCode.DC,
  "Washington": StateCode.WA,
  "WASHINGTON": StateCode.WA,
  "West Virginia": StateCode.WV,
  "WEST VIRGINIA": StateCode.WV,
  "Wisconsin": StateCode.WI,
  "WISCONSIN": StateCode.WI,
  "Wyoming": StateCode.WY,
  "WYOMING": StateCode.WY,
}

export const StateCodeToName: Record<StateCode, StateName> = {
  [StateCode.AL]: `Alabama`,
  [StateCode.AK]: `Alaska`,
  [StateCode.AZ]: `Arizona`,
  [StateCode.AR]: `Arkansas`,
  [StateCode.CA]: `California`,
  [StateCode.CO]: `Colorado`,
  [StateCode.CT]: `Connecticut`,
  [StateCode.DE]: `Delaware`,
  [StateCode.FL]: `Florida`,
  [StateCode.GA]: `Georgia`,
  [StateCode.HI]: `Hawaii`,
  [StateCode.ID]: `Idaho`,
  [StateCode.IL]: `Illinois`,
  [StateCode.IN]: `Indiana`,
  [StateCode.IA]: `Iowa`,
  [StateCode.KS]: `Kansas`,
  [StateCode.KY]: `Kentucky`,
  [StateCode.LA]: `Louisiana`,
  [StateCode.ME]: `Maine`,
  [StateCode.MD]: `Maryland`,
  [StateCode.MA]: `Massachusetts`,
  [StateCode.MI]: `Michigan`,
  [StateCode.MN]: `Minnesota`,
  [StateCode.MS]: `Mississippi`,
  [StateCode.MO]: `Missouri`,
  [StateCode.MT]: `Montana`,
  [StateCode.NE]: `Nebraska`,
  [StateCode.NV]: `Nevada`,
  [StateCode.NH]: `New Hampshire`,
  [StateCode.NJ]: `New Jersey`,
  [StateCode.NM]: `New Mexico`,
  [StateCode.NY]: `New York`,
  [StateCode.NC]: `North Carolina`,
  [StateCode.ND]: `North Dakota`,
  [StateCode.OH]: `Ohio`,
  [StateCode.OK]: `Oklahoma`,
  [StateCode.OR]: `Oregon`,
  [StateCode.PA]: `Pennsylvania`,
  [StateCode.RI]: `Rhode Island`,
  [StateCode.SC]: `South Carolina`,
  [StateCode.SD]: `South Dakota`,
  [StateCode.TN]: `Tennessee`,
  [StateCode.TX]: `Texas`,
  [StateCode.UT]: `Utah`,
  [StateCode.VT]: `Vermont`,
  [StateCode.VA]: `Virginia`,
  [StateCode.WA]: `Washington`,
  [StateCode.DC]: `Washington DC`,
  [StateCode.WV]: `West Virginia`,
  [StateCode.WI]: `Wisconsin`,
  [StateCode.WY]: `Wyoming`,
  [StateCode.PR]: `Puerto Rico`,
}
